module.exports = __webpack_public_path__ + "static/media/default.542b39ab.jpg";